var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3391_3196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20C24.3674 20 24.2402 20.0527 24.1464 20.1464C24.0527 20.2402 24 20.3674 24 20.5V24H12V12H15.5C15.6326 12 15.7598 11.9473 15.8536 11.8536C15.9473 11.7598 16 11.6326 16 11.5C16 11.3674 15.9473 11.2402 15.8536 11.1464C15.7598 11.0527 15.6326 11 15.5 11H11.5C11.3674 11 11.2402 11.0527 11.1464 11.1464C11.0527 11.2402 11 11.3674 11 11.5V24.5C11 24.6326 11.0527 24.7598 11.1464 24.8536C11.2402 24.9473 11.3674 25 11.5 25H24.5C24.6326 25 24.7598 24.9473 24.8536 24.8536C24.9473 24.7598 25 24.6326 25 24.5V20.5C25 20.3674 24.9473 20.2402 24.8536 20.1464C24.7598 20.0527 24.6326 20 24.5 20Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0029 11.3105C24.9513 11.1889 24.8545 11.0921 24.7329 11.0405C24.6704 11.0256 24.6054 11.0256 24.5429 11.0405H19.5429C19.4103 11.0405 19.2831 11.0931 19.1893 11.1869C19.0956 11.2807 19.0429 11.4078 19.0429 11.5405C19.0429 11.6731 19.0956 11.8002 19.1893 11.894C19.2831 11.9878 19.4103 12.0405 19.5429 12.0405H23.3329L18.1829 17.1905C18.0907 17.2856 18.0391 17.4129 18.0391 17.5455C18.0391 17.678 18.0907 17.8053 18.1829 17.9005C18.2306 17.9465 18.287 17.9826 18.3488 18.0066C18.4106 18.0307 18.4766 18.0422 18.5429 18.0405C18.6076 18.0414 18.6718 18.0295 18.7319 18.0055C18.792 17.9814 18.8467 17.9457 18.8929 17.9005L24.0029 12.7105V16.5005C24.0029 16.6331 24.0556 16.7602 24.1493 16.854C24.2431 16.9478 24.3703 17.0005 24.5029 17.0005C24.6355 17.0005 24.7627 16.9478 24.8565 16.854C24.9502 16.7602 25.0029 16.6331 25.0029 16.5005V11.5005C25.0178 11.438 25.0178 11.3729 25.0029 11.3105Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3391_3196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.628042e01a7884f402da448931d043e1.svg";
export { ForwardRef as ReactComponent };